import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { TimelineLite, TweenLite } from 'gsap'
import AjaxLoaderImg from './AjaxLoaderImg'
import Button from '../elements/Button'
import ReactModal from '../modules/ReactModal'
import globals from '../globals'
import { TYPE_ALLOWED } from '../constants'

const RemovableList = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const removeAllError = useRef(null)

    const myRefs = []
    props.data.forEach((item, key) => {
        myRefs[key] = useRef(null)
    })

    const handleRemove = (event, key) => {
        event.preventDefault()

        const tl = new TimelineLite()
        const link = myRefs[key].current.querySelector('.remove')
        const loader = myRefs[key].current.querySelector('.loader-container')
        const error = myRefs[key].current.querySelector('.error')
        tl.set(error, { display: 'none', opacity: 0 })
        tl.add(() => {
            setIsLoading(true)
        })
        tl.to(link, 0.1, { opacity: 0 })
        tl.to(loader, 0.1, { display: 'block', opacity: 1 })

        let data = [...props.data]
        if (data.length > 1) {
            data.splice(key, 1)
        } else {
            data = []
        }

        props.handleRemove(data, props.type).then(updateData => {
            const tl = new TimelineLite()
            tl.to(myRefs[key].current, 0.3, { height: 0, opacity: 0 })
            tl.set(myRefs[key].current, { display: 'none' })
            tl.add(() => {
                setIsLoading(false)
            })
            tl.add(() => {
                updateData()
            })
            globals.pushEvent(props.type === TYPE_ALLOWED ? 'HsAllowSiteUrlRemove' : 'HsBlockSiteUrlRemove')
        }).catch(() => {
            setIsLoading(false)
            TweenLite.to(error, 0.1, { display: 'block', opacity: 1 })
        })
    }

    const handleRemoveAll = (event) => {
        event.preventDefault()
        setIsLoading(true)
        setShowModal(false)

        props.handleRemove([], props.type).then(updateData => {
            setIsLoading(false)
            updateData()
            globals.pushEvent(props.type === TYPE_ALLOWED ? 'HsAllowSiteUrlRemoveAll' : 'HsBlockSiteUrlRemoveAll')
        }).catch(() => {
            setIsLoading(false)
            TweenLite.to(removeAllError.current, 0.1, { display: 'block', opacity: 1 })
        })
    }

    const handleShowModal = (event) => {
        event.preventDefault()
        setShowModal(true)
    }

    const handleCloseModal = (event) => {
        event.preventDefault()
        setShowModal(false)
    }

    const NoResults = (
        <tr>
            <td className='text-center'>
                No results
            </td>
        </tr>
    )

    return (
        <React.Fragment>
            <div className='removable-list'>
                <table cellPadding='0' cellSpacing='0'>
                    <thead>
                        <tr>
                            <td>
                                <div className='d-flex align-items-center'>
                                    <div className='w-50 text-left'>{props.title}</div>
                                    <div className='w-50 text-right'>
                                        {isLoading
                                            ? <a href='#' className='remove font-small regular' onClick={event => event.preventDefault()} style={{ opacity: 0.4 }}>remove all</a>
                                            : <a href='#' className='remove font-small regular' onClick={event => handleShowModal(event)}>remove all</a>}
                                        <div ref={removeAllError} className='error'>
                                            Something went wrong.
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.length === 0 ? NoResults : null}
                        {props.data.map((item, key) => {
                            return (
                                <tr key={key} ref={myRefs[key]}>
                                    <td>
                                        <div className='d-flex align-items-center' style={{ opacity: isLoading ? 0.4 : 1 }}>
                                            <div className='left-block text-left' title={item}>{item}</div>
                                            <div className='right-block text-right position-relative'>
                                                {isLoading
                                                    ? <a href='#' className='font-small' onClick={event => event.preventDefault()} style={{ opacity: 0.4 }}>remove</a>
                                                    : <a href='#' className='remove font-small' onClick={event => handleRemove(event, key)}>remove</a>}
                                                <div className='loader-container'>
                                                    <AjaxLoaderImg width='30px' />
                                                </div>
                                                <div className='error'>
                                                    Something went wrong.
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <ReactModal showModal={showModal} handleCloseModal={() => setShowModal(false)} heading='Confirmation'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <p className='mt-0 mb-4'>Please confirm you would like to <span className='bold'>remove all</span> items in this list?</p>
                        <div className='d-flex justify-content-center'>
                            <Button title='Confirm' action={event => handleRemoveAll(event)} className='mr-3' />
                            <Button title='Cancel' action={event => handleCloseModal(event)} color='red' />
                        </div>
                    </div>
                </div>
            </ReactModal>
        </React.Fragment>
    )
}

RemovableList.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    handleRemove: PropTypes.func.isRequired,
    type: PropTypes.string // Just a differentiator for functions
}

RemovableList.defaultProps = {
    data: [],
    type: ''
}

export default RemovableList



// WEBPACK FOOTER //
// ./resources/js/components/RemovableList.js